import React from "react";
import { ContactForm } from "../componets/ContactForm";
import comment from "../Assets/comment_icon.png";
import phone from "../Assets/contact/phone.png";
import mail from "../Assets/contact/mail.png";
import linkIn from "../Assets/contact/linkIn.png";
import gith from "../Assets/contact/gith.png";
import be from "../Assets/contact/be.png";
import "./Contact.css";

import { Fotter } from "../componets/Fotter";
const handleEmailClick = () => {
    const emailAddress = 'susana.garcia.dev@gmail.com<';
    window.location.href = `mailto:${emailAddress}`;
  };
 const linkedinURL = 'https://www.linkedin.com/in/susana-front-end-uiux';
 const phonet = 'https://drive.google.com/file/d/1I0tHDApz0Mj7k8ngtV_dPgS6LoRKytXO/view?usp=sharing';
const Contact = () => {
  return (
    
    <div >
    
      <div className="contact-container">
        <div className="contact-header">
          <div className="contact-info">
            <h1 className="contact-title">Let's talk</h1>
            <div className="contact-details">
              <div className="contact-item">
                <img src={phone} alt="con-icon" className="con-icon" />
                <a className="url" href={phonet} target="_blank" rel="noopener noreferrer" > Add my number</a>
              </div>
              <div className="contact-item">
                <img src={mail} alt="con-icon" className="con-icon" />
                <a  className="dev" onClick={handleEmailClick}>susana.garcia.dev@gmail.com</a>
              </div>
              <div className="contact-item">
                <img src={linkIn} alt="con-icon" className="con-icon" />
                <a className="url" href={linkedinURL} target="_blank" rel="noopener noreferrer">susana-front-end-uiux</a>
              </div>
            </div>
          </div>

          <img src={comment} alt="con-icon" className="comment" />
        </div>
        <div className="contact-icons">
          <a
            href="https://www.behance.net/susanagarcia37"
          >
            <img src={be} alt="con-icon" className="con-icon" /> 
          </a>
          <a  href="https://github.com/SusanaLab">
           <img src={gith} alt="con-icon" className="con-icon" />
          </a>
        </div>
      </div>
      <ContactForm />
      <Fotter />
    </div>
  );
};

export default Contact;
